export interface ILocation {
    hash: string;
    key: string;
    pathname: string;
    search: any;
    state: any;
}

export interface ISelectedFilter {
    label: string;
    value: string;
}

export enum BUILDER_STATES {
    EDIT = 'edit',
    PREVIEW = 'preview',
    SMARTPROBE = 'smartprobe',
    LOGIC = 'logic'
}

export interface News {
    imageUrl: string;
    linkText: string;
    title: string;
    content: string;
    order?: number;
    hidden?: boolean;
    moreText: 'string';
    moreUrl: 'string';
}
